export interface CheckboxOptionModel {
  id: string;
  name: string;

  /** That option's index in the array. */
  index?: number;
}
